import { render, staticRenderFns } from "./AuthorListRow.vue?vue&type=template&id=a234c912&"
import script from "./AuthorListRow.vue?vue&type=script&lang=js&"
export * from "./AuthorListRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports